import HttpRequest from '../request'
import { GlobalBizApi } from '../api'
import type { Response } from '../request'
import type {
  GlobalBizAllocation,
  GlobalBizContract,
  GlobalBizEligibility,
  GlobalBizMember,
  GlobalBizMemberList,
  GlobalBizRemotePreflight,
  GlobalBizSite,
  GlobalBizVerificationConfirm,
  GlobalBizVerificationIssue,
  GlobalBizFuelPackage,
  GlobalBizFuelAllocation,
} from './types'

export default {
  eligibility(tradeType?: number): Promise<Response<GlobalBizEligibility>> {
    return HttpRequest.get(GlobalBizApi.eligibility, tradeType === undefined ? null : { tradeType })
  },
  contract(orderNo: string): Promise<Response<GlobalBizContract>> {
    return HttpRequest.get(GlobalBizApi.contract, { orderNo })
  },
  pendingContract(): Promise<Response<GlobalBizContract | null>> {
    return HttpRequest.get(GlobalBizApi.pendingContract, null)
  },
  issueVerification(params: { contractNo: string; remoteEmail: string }): Promise<Response<GlobalBizVerificationIssue>> {
    return HttpRequest.post(GlobalBizApi.issueVerification, params)
  },
  confirmVerification(params: { challengeId: string; code: string }): Promise<Response<GlobalBizVerificationConfirm>> {
    return HttpRequest.post(GlobalBizApi.confirmVerification, params)
  },
  remotePreflight(params: {
    contractNo: string
    email: string
    conflictResolution: 'NONE' | 'OVERRIDE'
  }): Promise<Response<GlobalBizRemotePreflight>> {
    return HttpRequest.post(GlobalBizApi.remotePreflight, params)
  },
  prepareBinding(params: {
    contractNo: string
    businessName?: string
    conflictResolution: 'NONE' | 'OVERRIDE'
    consentToken?: string
    entitlementSnapshotHash?: string
  }): Promise<Response<unknown>> {
    return HttpRequest.post(GlobalBizApi.prepareBinding, params)
  },
  members(contractNo: string): Promise<Response<GlobalBizMemberList>> {
    return HttpRequest.get(GlobalBizApi.members, { contractNo })
  },
  addMember(params: {
    contractNo: string
    region: GlobalBizSite
    inviteAccount: string
    aliasName: string
    permission: string
    roleType: number
  }): Promise<Response<GlobalBizMember>> {
    return HttpRequest.post(GlobalBizApi.addMember, params)
  },
  editMember(params: {
    contractNo: string
    region: GlobalBizSite
    memberId: number
    aliasName: string
    permission: string
    roleType: number | null
  }): Promise<Response<GlobalBizMember>> {
    return HttpRequest.post(GlobalBizApi.editMember, params)
  },
  removeMember(params: { contractNo: string; region: GlobalBizSite; memberId: number }): Promise<Response<GlobalBizMember>> {
    return HttpRequest.post(GlobalBizApi.removeMember, params)
  },
  allocate(params: {
    contractNo: string
    orderNo?: string
    aiQuota: number
    vipQuota: number
    expectedAllocationVersion: number
    sourceEntitlementSnapshotHash?: string
  }): Promise<Response<GlobalBizAllocation>> {
    return HttpRequest.post(GlobalBizApi.allocate, params)
  },
  pendingFuel(): Promise<Response<GlobalBizFuelPackage | null>> {
    return HttpRequest.get(GlobalBizApi.pendingFuel, null)
  },
  allocateFuel(params: {
    packageNo: string
    aiQuota: number
    vipQuota: number
  }): Promise<Response<GlobalBizFuelAllocation>> {
    return HttpRequest.post(GlobalBizApi.allocateFuel, params)
  },
}
